import Checkbox from './Checkbox';
import './CheckboxField.css';

const CheckboxField = ({children, disabled, grey, ...props}) => {
  return(
    <button disabled={disabled} onClick={()=>props?.onChange?.(!props?.checked)} className={`checkbox-field-component ${disabled ? 'disabled':''} ${grey? 'grey': ''} ${props.checked ? 'checked': ''}`}>
      <Checkbox {...props}/>
      {children}
    </button>
  )
}

export default CheckboxField;